import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Button} from "reactstrap"
import {bulkDeleteSku} from "../../../../services/api/apiSku"
import ModalConfirm from "./ModalConfirm"
import {message} from "antd"

class DeleteProduct extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isOpen: false,
            loading: false,
            error: '',
        }
    }

    _toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen
        })
    }

    _bulkActionDelete = async () => {
        this.setState({
            loading: true,
            error: ''
        })

        try {
            const {arrSelected} = this.props

            const {'data': responsive} = await bulkDeleteSku({ids: arrSelected})

            const {success, message: error} = responsive

            if (!success) {
                return this.setState({
                    loading: false,
                    error: error
                })
            }

            this.setState({
                loading: false,
                error: '',
            }, () => {
                const {onRefresh, closeOpen} = this.props

                this._toggle()

                if (typeof onRefresh === 'function') {
                    onRefresh()
                }

                if (typeof closeOpen === 'function') {
                    closeOpen()
                }

                message.success('Xóa sản phẩm thành công');
            })
        } catch (err) {
            this.setState({
                loading: false,
                error: err.message
            })
        }
    }

    render() {
        const {arrSelected} = this.props
        const {isOpen, loading, error} = this.state

        return (
            <div className='DeleteProduct'>
                <Button onClick={this._toggle} color='link'>Xóa Sản phẩm</Button>
                <ModalConfirm isOpen={isOpen} loading={loading} error={error} toggle={this._toggle}
                              arrSelected={arrSelected}
                              onDelete={this._bulkActionDelete}/>
            </div>
        )
    }
}

DeleteProduct.propTypes = {
    arrSelected: PropTypes.array,
    onRefresh: PropTypes.func
}

export default DeleteProduct